/* global jQuery */

/**
 * Front end JS.
 */

// Helper - Media Queries.
import { getMediaQueryBreakpoint } from './helper/mediaQueries';

// Autoplay Videos.
import { autoplayVideos } from './video/autoplay';

// Add Controllers to videos.
import { videoElementControllers } from './video/controller';

// Tabs.
// eslint-disable-next-line import/no-extraneous-dependencies
import 'van11y-accessible-tab-panel-aria';

// Accessibility.
import {
	buttonBlocks,
	tableBlocks,
	sfHeadings,
	updateProjectCardTabOrder,
	wpStoreLocatorError,
	wpStoreLocatorExternalLinks,
} from './accessibility/accessibility';

// Header.
import { mobileNav } from './header/mobile-nav';
import { Nav } from './header/nav';
import { headerSearch } from './header/search';
import { mobileFooterNav } from './footer/mobile-footer-nav';

// Hero.
import { productGalleryMobile } from './hero/product-gallery-mobile';
import { productGalleryDesktop } from './hero/product-gallery-desktop';
import { productBuyButtonMobile } from './hero/product-buy-button-mobile';

// Search & Filter.
import { sfAccordions } from './search-filter/search-filter';

// Product Pages.
import { mobileAccordion } from './product/mobile-accordion';

// Modal.
import { modalSwal } from './modal/swal';

// Mavenoid.
import {
	addMavenoidScript,
	chatbotDesktop,
	chatbotMobile,
	chatbotShow,
} from './mavenoid/chatbot';

// Desktop Actions.
window.addEventListener( 'DOMContentLoaded', () => {
	// For all browsers.
	buttonBlocks();
	headerSearch();
	Nav();
	sfHeadings();
	sfAccordions();
	tableBlocks();
	modalSwal();
	addMavenoidScript();
	chatbotShow();
	autoplayVideos();
	videoElementControllers();
	updateProjectCardTabOrder();
	wpStoreLocatorError();
	wpStoreLocatorExternalLinks();

	// Mobile Actions.
	if (
		window.matchMedia(
			getMediaQueryBreakpoint( 'tablet-landscape', 'max' )
		).matches
	) {
		mobileNav();
		mobileFooterNav();
		productBuyButtonMobile();
		productGalleryMobile();
		mobileAccordion();
		chatbotMobile();
	}

	// Desktop Actions.
	if (
		window.matchMedia( getMediaQueryBreakpoint( 'tablet-landscape' ) )
			.matches
	) {
		productGalleryDesktop();
		chatbotDesktop();
	}
} );

// Search & Filter - on ajax finish.
if ( typeof jQuery !== 'undefined' ) {
	jQuery( document ).on( 'sf:ajaxfinish', '.searchandfilter', function () {
		sfHeadings();
		sfAccordions();
		modalSwal();
	} );
}
